import { createFileRoute } from "@tanstack/react-router";
import { useI18n } from "@/lib/i18n";
import { PageShell } from "@/components/site/PageShell";
import { LegalContent } from "@/components/site/LegalContent";

export const Route = createFileRoute("/$lang/legal")({
  head: ({ params }) => ({
    meta: [
      { title: "Legal — MadCaptains" },
      {
        name: "description",
        content:
          "Terms of Service, Privacy Policy, and Editorial & Takedown Policy for MadCaptains.net — a moderated, multilingual archive of anonymous testimony from merchant seafarers.",
      },
      { property: "og:title", content: "Legal — MadCaptains" },
      { property: "og:url", content: `/${params.lang}/legal` },
    ],
    links: [{ rel: "canonical", href: `/${params.lang}/legal` }],
  }),
  component: LegalPage,
});

function LegalPage() {
  const { t } = useI18n();
  return (
    <>
      <PageShell title={t.page_legal_h1} lead={t.page_legal_lead} />
      <LegalContent />
    </>
  );
}